import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 49 49"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M48.4 45.4 36.7 33.7c3-3.4 4.7-8.1 4.7-13C41.3 9.2 32 0 20.7 0S0 9.2 0 20.7s9.2 20.7 20.7 20.7 9.4-1.7 13-4.7l11.7 11.7c.9.9 2.1.9 3 0s.9-2.1 0-3m-27.7-8.1c-9.2 0-16.6-7.5-16.6-16.6S11.6 4.1 20.7 4.1s16.6 7.5 16.6 16.6-7.5 16.6-16.6 16.6",
      "data-name": "Ebene_1"
    }, null, -1)
  ]))]))
}
export default { render: render }